import { StorageEngine } from '@ngxs/storage-plugin';
import { Injectable } from '@angular/core';

@Injectable()
export class PuzzleStorageEngine implements StorageEngine {
  // @TODO: put this into own file and make this backwards-compatible

  get length(): number {
    // Your logic here
    return localStorage.length;
  }

  public oldConsentGiven(): boolean {
    // Check and remove old consent keys
    let return_value = false;
    // This is to not loose old consent
    if (localStorage.getItem('krupion-consent') === 'true') {
      this.setConsent();
      this.removeItem('krupion-consent');
      return_value = true;
    }
    if (localStorage.getItem('analyticsConsent') === 'true') {
      this.setConsent();
      this.removeItem('analyticsConsent');
      return_value = true;
    }
    return return_value;
  }

  private isConsentGiven(): boolean {
    return localStorage.getItem('cookieConsent') === 'true';
  }

  setConsent() {
    localStorage.setItem('cookieConsent', 'true');
  }

  revokeConsent() {
    localStorage.removeItem('cookieConsent');
  }

  getItem(key: string): any {
    const data = localStorage.getItem(key);
    // if (typeof data !== 'string') {
    //   return data;
    // }
    // const val = data ? atob('' + data) : data;
    // return val;
    return data;
  }

  setItem(key: string, val: any): void {
    // if (typeof val !== 'string') {
    //   return;
    // }
    // const data = val ? btoa('' + val) : val;
    // localStorage.setItem(key, data);
    if (this.isConsentGiven()) {
      localStorage.setItem(key, val);
    } else {
      localStorage.clear();
    }
  }

  removeItem(key: string): void {
    // Your logic here
    return localStorage.removeItem(key);
  }

  clear(): void {
    // Your logic here
    return localStorage.clear();
  }

  key(val: number): string {
    // Your logic here
    return Object.keys(localStorage)[val];
  }
}
